var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-image-link bgc11 u-tac"},[(_vm.imageId)?_c('a',{attrs:{"href":_vm.link}},[_c('img',{style:({ maxWidth: (_vm.maxWidth + "%") }),attrs:{"src":_vm.getImageUrl({ id: _vm.imageId })}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }